module.exports = __webpack_public_path__ + "img/edit.131e2481.svg";